export default __webpack_public_path__ + "static/media/team5.900e75aa.png";